import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const PersonalDataContainer = styled.section``

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`

export const PendencySelection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const InputsContainer = styled.div`
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  align-items: end;

  section {
    display: flex;
    gap: 16px;
  }

  @media (max-width: 1600px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;

    input {
      margin-right: 24px;
    }
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    input {
      margin-right: 16px;
    }
  }

  section {
    display: flex;
    align-items: end;
  }

  > input:last-child {
    margin-right: 0;
  }
`

export const ContactsContainer = styled.section`
  margin-top: 80px;
`

export const AddressContainer = styled.section`
  margin-top: 80px;
`

export const DirectorObservations = styled.div`
  margin-top: 48px;

  textarea {
    height: 160px;
  }
`

export const PendencyJustification = styled.div`
  margin-top: 48px;

  textarea {
    height: 160px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`
